import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_PROCESS_BY_ID } from './get-process-by-id.hook';
import { IHookCallbacks } from '../common.hooks.interfaces';



export const UPDATE_PROCESS = gql`
  mutation updateProcess($processId: ObjectId!, $payload: UpdateProcessInput!) {
    updateProcess(processId: $processId, payload: $payload) {
      _id
    }
  }
`;

export const useUpdateProcess = ({ onSuccess }: IHookCallbacks) => {
  const { t } = useTranslation('employee');
  const [updateProcess, { loading }] = useMutation(UPDATE_PROCESS, {
    onCompleted: data => {
      if (data?.updateProcess?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('process.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [GET_PROCESS_BY_ID],
  });

  return { updateProcess, loading };
};
